module.exports = __webpack_public_path__ + "img/banner-sm.a91c42df.png";